/**
 * Presigned URL Value Object
 * Represents a temporary download URL for accessing PASCO files
 */
export interface PresignedUrlProps {
    downloadUrl: string;
    expiresAt: Date;
    pascoId: string;
}

export class PresignedUrl {
    private constructor(private readonly props: PresignedUrlProps) { }

    static create(props: PresignedUrlProps): PresignedUrl {
        return new PresignedUrl(props);
    }

    get downloadUrl(): string {
        return this.props.downloadUrl;
    }

    get expiresAt(): Date {
        return this.props.expiresAt;
    }

    get pascoId(): string {
        return this.props.pascoId;
    }

    /**
     * Check if the URL has expired
     */
    isExpired(): boolean {
        return new Date() > this.props.expiresAt;
    }

    /**
     * Get time remaining until expiration in milliseconds
     */
    getTimeRemaining(): number {
        return Math.max(0, this.props.expiresAt.getTime() - new Date().getTime());
    }

    /**
     * Check if URL will expire soon (within 5 minutes)
     */
    isExpiringSoon(): boolean {
        const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
        return this.getTimeRemaining() <= fiveMinutes;
    }
}
